export const TempoRange = { min: 30, max: 1000 };
